module.exports = __webpack_public_path__ + "assets/icons/ic_report_24px.svg";